import { createBrowserRouter } from "react-router"
import Home, { permissionLoader } from "./features/home/Home"
import Login from "./features/login/Login"
import ErrorPage, { ErrorStatus } from "@features/errors/ErrorPage"
import Administration from "./features/administration/Administration"
import Organisations from "./features/administration/organisations/Organisations"
import OrganisationForm from "./features/administration/organisations/organisation-form/OrganisationForm"
import UserForm from "./features/administration/users/UserForm"
import Users from "./features/administration/users/Users"
import Contracts from "./features/administration/contracts/Contracts"
import Products from "./features/administration/products/Products"
import RunRoute from "@features/run/RunRoute"
import ViewModel from "@features/run/viewModel/ViewModel"
import RawResults from "@features/results/Result/RawResults"
import Results from "@features/results/Results"
import { AddUserForm } from "@features/administration/users/AddUserForm"
import { AddContract } from "@features/administration/contracts"
import { EditContract } from "@features/administration/contracts/EditContract"
import { RunProgress } from "@features/run/runProgress/runProgress"
import { EditProduct } from "@features/administration/products/EditProduct"
import { AddProduct } from "@features/administration/products/AddProduct"
import ScenarioDesignPage from "@features/scenarioDesign/ScenarioDesignPage"
import { BaseGraphEdit } from "@features/administration/products/BaseGraph"
import Comparison from "@features/results/Comparison/Comparison"
import { LandingPage } from "@features/home/LandingPage"
import GraphBuilderPage from "@features/builder/GraphBuilderPage"
import { GraphBuilderPagePath } from "@features/builder/const"
import PublishApprovals from "@features/administration/approvals/PublishApprovals"
import ApproveDenyGraphRunPage from "@features/administration/approvals/ApproveDenyGraphRun/ApproveDenyGraphRunPage"
import { ReactFlowProvider } from "@xyflow/react"
import { closeSnackbar } from "notistack"

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forbidden",
    element: <ErrorPage status={ErrorStatus.Forbidden} />,
  },
  {
    path: "/denied",
    element: <ErrorPage status={ErrorStatus.AccessDenied} />,
  },
  {
    path: "/",
    loader: permissionLoader,
    element: <Home />,
    errorElement: <ErrorPage status={ErrorStatus.SomethingWentWrong} />,
    //  @TODO (Bartek Laskowski) 2026-01-26: replace with Loading component
    hydrateFallbackElement: <div />,
    children: [
      {
        path: "/Administration",
        element: <Administration />,
      },
      {
        path: "/Administration/Organisations",
        element: <Organisations />,
      },
      {
        path: "/Administration/Organisations/:id",
        element: <OrganisationForm />,
      },
      {
        path: "/Administration/Users",
        element: <Users />,
      },
      {
        path: "/Administration/Users/new",
        element: <AddUserForm />,
      },
      {
        path: "/Administration/Users/:id/:orgId?",
        element: <UserForm />,
      },
      {
        path: "/Administration/Contracts",
        element: <Contracts />,
      },
      {
        path: "/Administration/Contracts/new",
        element: <AddContract />,
      },
      {
        path: "/Administration/Contracts/:id/:orgId?",
        element: <EditContract />,
      },
      {
        path: "/Administration/Products",
        element: <Products />,
      },
      {
        path: "/Administration/Products/:key/:orgKey/:divKey",
        element: <EditProduct />,
      },
      {
        path: "/Administration/Products/new",
        element: <AddProduct />,
      },
      {
        path: "/Administration/BaseGraphs/:key",
        element: <BaseGraphEdit />,
      },
      {
        path: "/Administration/Publish-Approvals",
        element: <PublishApprovals />,
      },
      {
        path: "/Administration/Publish-Approvals/:approvalKey",
        element: <ApproveDenyGraphRunPage />,
      },
      {
        path: GraphBuilderPagePath,
        element: (
          <ReactFlowProvider>
            <GraphBuilderPage />
          </ReactFlowProvider>
        ),
      },
      {
        path: "/Run",
        element: <RunRoute />,
      },
      {
        path: "/Run/Progress/:id",
        element: <RunProgress />,
      },
      {
        path: "/Run/ViewModel/:id",
        element: <ViewModel />,
      },
      {
        path: "/Results/Result/:id",
        element: <RawResults />,
      },
      {
        path: "/Results",
        element: <Results />,
      },
      {
        path: "/ScenarioDesign",
        element: <ScenarioDesignPage />,
      },
      {
        path: "/Results/Comparison",
        element: <Comparison />,
      },
      {
        path: "/",
        element: <LandingPage />,
      },
    ],
  },
  {
    path: "/*",
    loader: permissionLoader,
    element: <ErrorPage status={ErrorStatus.NotFound} />,
  },
])

router.subscribe(() => {
  // close all snackbars on url change ticket 458505
  closeSnackbar()
})

export default router
